import { useState, useCallback } from 'react'
import { OfferedShipment, useGetAllOfferedShipments, useGetPastOfferedShipments } from '../types'

interface IUseShipmentOffersState {
  error?: string
  allShipmentOffers: OfferedShipment[]
  isLoading: boolean
  getAllShipmentOffers: () => Promise<OfferedShipment[] | undefined>
  findAllShipmentOffer: (shipmentId: number) => OfferedShipment | undefined
  shipmentOfferParam: 'isShipmentOffer'
  isPastLoading: boolean
  getPastShipmentOffers: () => Promise<OfferedShipment[] | undefined>
  pastError?: string
  pastShipmentOffers: OfferedShipment[]
}

export const useShipmentOffersApi = (): IUseShipmentOffersState => {
  const { mutate: getAllOfferedShipments } = useGetAllOfferedShipments({})
  const { mutate: getPastOfferedShipments } = useGetPastOfferedShipments({})
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isPastLoading, setIsPastLoading] = useState<boolean>(false)
  const [allShipmentOffers, setAllShipmentOffers] = useState<OfferedShipment[]>([])
  const [pastShipmentOffers, setPastShipmentOffers] = useState<OfferedShipment[]>([])
  const [error, setError] = useState<string>('')
  const [pastError, setPastError] = useState<string>('')

  const getAllShipmentOffers = useCallback(async (): Promise<OfferedShipment[] | undefined> => {
    setError('')
    setIsLoading(true)
    try {
      const { offeredShipments = [] } = await getAllOfferedShipments()
      setAllShipmentOffers(offeredShipments)
      setIsLoading(false)
      return offeredShipments
    } catch (e) {
      setError(e)
      setIsLoading(false)
      return undefined
    }
  }, [])

  const getPastShipmentOffers = useCallback(async (): Promise<OfferedShipment[] | undefined> => {
    setPastError('')
    setIsPastLoading(true)
    try {
      const { pastOffers: pastShipments = [] } = await getPastOfferedShipments()
      setPastShipmentOffers(pastShipments)
      setIsPastLoading(false)
      return pastShipments
    } catch (e) {
      setPastError(e)
      setIsPastLoading(false)
      return undefined
    }
  }, [])

  const findAllShipmentOffer = useCallback(
    (shipmentId: number): OfferedShipment | undefined => {
      return allShipmentOffers.find(shipmentOffer => shipmentOffer.externalId === shipmentId)
    },
    [allShipmentOffers]
  )

  const shipmentOfferParam = 'isShipmentOffer'

  return {
    error,
    allShipmentOffers,
    isLoading,
    getAllShipmentOffers,
    findAllShipmentOffer,
    shipmentOfferParam,
    isPastLoading,
    getPastShipmentOffers,
    pastError,
    pastShipmentOffers,
  }
}
